export const comments_3411658 = {"data":{"data":[],"links":{}}}